import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

/**
 * Jira entity card for the overview page.
 *
 * The Jira plugin has no alpha export, so we wrap the legacy component
 * with `compatWrapper` and register it as an `EntityCardBlueprint`.
 */
const jiraCard = EntityCardBlueprint.make({
  name: 'jira',
  params: {
    filter: {
      'metadata.annotations.jira/project-key': { $exists: true },
    },
    loader: async () => {
      const { EntityJiraOverviewCard } = await import(
        '@roadiehq/backstage-plugin-jira'
      );
      return compatWrapper(<EntityJiraOverviewCard />);
    },
  },
});

export const jiraCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [jiraCard],
});
